module.exports = __webpack_public_path__ + "purchase-group.svg?629474553cc453e8cde8d04d43d9a59b";